class Paths {
  CHAT_ASSISTANT = "/chat-assistant";
  ADD_NEW_DOCUMENTS = "/add-new-documents";
  HELP_SECTION = "/help";
}

export const paths = new Paths();
